module.exports = __webpack_public_path__ + "img/doctor.fa417d86.png";